import {
  DetailedHTMLProps,
  FC,
  HTMLAttributes,
  ReactNode,
  useMemo,
} from 'react';

import classNames from 'classnames';

import './TableHead.scss';

import { TestMetadata } from '../types';

export interface Props
  extends DetailedHTMLProps<
    HTMLAttributes<HTMLTableSectionElement>,
    HTMLTableSectionElement
  > {
  /** Table head content */
  children?: ReactNode;
  /** Table head classname */
  className?: string;
  /** Sticky header */
  sticky?: boolean;
  /** Fill background */
  fill?: boolean;
  // Test IDs for component sections
  testMetadata?: TestMetadata;
  // When screen size is small //
  vertical?: boolean;
}

const TableHead: FC<Props> = ({
  children,
  className,
  sticky,
  fill,
  testMetadata,
  vertical,
  ...otherProps
}) => {
  const tableHeadClassName = useMemo(
    () =>
      classNames('sb-table-head', {
        'sb-table-head-horizontal': vertical !== true,
        'sb-table-head-vertical': vertical === true,
      }),
    [vertical],
  );

  return (
    <thead
      {...otherProps}
      className={classNames(
        tableHeadClassName,
        sticky && 'sb-table-head_sticky',
        fill && 'sb-table-head_fill',
        className,
      )}
      {...testMetadata}
    >
      {children}
    </thead>
  );
};

export default TableHead;
